import React from 'react'
import { Box } from '@mui/material'
import { PDFDownloadLink } from '@react-pdf/renderer'
import ResumenPDF from 'components/pdf/ResumenPDF'
import PDFButton from './PDFButton'
import { useResumenTables } from 'context/ResumenTablesContext'
import HeaderResumen from './HeaderResumen'
import ResumenTables from './ResumenTables'

const ResumenContent = () => {
  const {
    tables,
    totalImportProject,
    totalMo,
    totalImporte,
    numeroDivision,
    currentProject,
    isSaveDisabled,
  } = useResumenTables()

  const getSection = title =>
    tables.find(t => t.title === title) || { data: [], total: 0 }

  const { data: compraSolar, total: totalCompraSolar } =
    getSection('Compra Solar')
  const { data: construccion, total: totalConstruccion } =
    getSection('Construcción')
  const { data: costesGenerales, total: totalCostesGenerales } =
    getSection('Costes Generales')
  const { data: otrosHonorarios, total: totalOtrosHonorarios } =
    getSection('Otros Honorarios')

  const fabricacionIndustrial_v2 = totalImportProject + Number(totalMo)

  const resumenProps = {
    currentProject,
    fabricacionIndustrial_v2,
    compraSolar,
    totalCompraSolar,
    construccion,
    totalConstruccion,
    costesGenerales,
    totalCostesGenerales,
    otrosHonorarios,
    totalOtrosHonorarios,
    totalImporte,
    numeroDivision,
  }

  
  return (
    <Box sx={{ m: 2, height: '100vh', overflowY: 'auto', p: 2 }}>
      <HeaderResumen />
      <ResumenTables />

      <Box mt={2}>
        <PDFDownloadLink
          document={
            <ResumenPDF
              resumen={resumenProps}
            />
          }
          fileName="resumen_proyecto.pdf"
          style={{ textDecoration: 'none' }}
        >
          {({ loading }) => (
            <PDFButton isSaveDisabled={isSaveDisabled} loading={loading} />
          )}
        </PDFDownloadLink>
      </Box>
    </Box>
  )
}

export default ResumenContent
